import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mobileSidebar', 'overlay', 'input']

  // Navigate to URL with parameter
  goToUrl = (event) => {
    const button = event.currentTarget
    const baseUrl = button.dataset.baseUrl
    const url = button.dataset.url
    const param = button.dataset.param
    const input = this.element.querySelector(`#${param}`)

    if (input && input.value) {
      window.location = baseUrl + url + input.value
    }
  }

  // Handle Enter key on inputs
  handleEnter = (event) => {
    if (event.key === 'Enter') {
      const input = event.currentTarget
      const buttonId = input.dataset.button
      const button = this.element.querySelector(`#${buttonId}`)

      if (button) {
        button.click()
      }
    }
  }

  // Toggle mobile sidebar
  toggleSidebar = () => {
    this.mobileSidebarTarget.classList.toggle('-translate-x-full')
    this.overlayTarget.classList.toggle('hidden')
  }

  // Close mobile sidebar
  closeSidebar() {
    this.mobileSidebarTarget.classList.add('-translate-x-full')
    this.overlayTarget.classList.add('hidden')
  }
}
